import React from 'react';
import {Navbar, Header, Work, About, Contact, Footer} from './containers'
import './App.css';

const App = () => {
  return (
      <div className="App">
          <Navbar className="navbar" />
          <Header className="header"/>
          <Work />
          <About />
          <Contact />
          <Footer />
      </div>
  );
}

export default App;
